// Core imports
import * as React from 'react';
import * as moment from 'moment';

// Components imports
import DateRangePicker from 'react-daterange-picker';

// Models imports

// Style and misc imports
import './DateRangeSeparated.scss';

class DateRangeSeparated extends React.Component<
  IDateRangeSeparatedProps,
  IDateRangeSeparatedState
> {
  private calendarStartRef: any = null;
  private calendarEndRef: any = null;
  constructor(props: IDateRangeSeparatedProps) {
    super(props);

    this.state = {
      calendarStartIsOpen: false,
      calendarEndIsOpen: false,
      startDate: null,
      endDate: null
    };
  }

  /* 
    saveDates : Saves date range value using props actions
   */
  private saveDates = () => {
    const { startDate, endDate } = this.state;
    this.props.onDatesSelected({ start: startDate, end: endDate });
  };

  /* 
    openStartCalendar
   */
  private openStartCalendar = () => {
    this.setState({ calendarStartIsOpen: true });
    this.closeEndCalendar();
  };

  /* 
    closeStartCalendar
   */
  private closeStartCalendar = () => {
    this.setState({ calendarStartIsOpen: false });
  };

  /* 
    openEndCalendar
   */
  private openEndCalendar = () => {
    this.setState({ calendarEndIsOpen: true });
    this.closeStartCalendar();
  };

  /* 
    closeEndCalendar
   */
  private closeEndCalendar = () => {
    this.setState({ calendarEndIsOpen: false });
  };

  /* 
    handleShowStartCalendar : 
   */
  private handleShowStartCalendar = () => {
    this.state.calendarStartIsOpen
      ? this.closeStartCalendar()
      : this.openStartCalendar();
  };

  /* 
    handleShowEndCalendar : 
   */
  private handleShowEndCalendar = () => {
    this.state.calendarEndIsOpen
      ? this.closeEndCalendar()
      : this.openEndCalendar();
  };

  /* 
    setStartDate
   */
  private setStartDate = (startDate: moment.Moment) => {
    this.setState({ startDate }, () => {
      this.saveDates();
    });
    this.closeStartCalendar();
  };

  /* 
    setEndtDate
   */
  private setEndDate = (endDate: moment.Moment) => {
    this.setState({ endDate }, () => {
      this.saveDates();
    });
    this.closeEndCalendar();
  };

  public componentDidMount = () => {
    if (this.props.dates !== null) {
      this.setState({
        startDate: this.props.dates.start,
        endDate: this.props.dates.start
      });
    } else {
      this.setState({
        startDate: null,
        endDate: null
      });
    }
  };

  private handleStartClickOutside = (e: any) => {
    if (
      this.calendarStartRef == null ||
      this.calendarStartRef.contains == null
    ) {
      return;
    }
    if (this.calendarStartRef.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      calendarStartIsOpen: false
    });
  };

  private handleEndClickOutside = (e: any) => {
    if (this.calendarEndRef == null || this.calendarEndRef.contains == null) {
      return;
    }
    if (this.calendarEndRef.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      calendarEndIsOpen: false
    });
  };

  public componentWillMount() {
    document.addEventListener('mousedown', this.handleStartClickOutside, false);
    document.addEventListener('mousedown', this.handleEndClickOutside, false);
  }

  public componentWillUnmount() {
    document.removeEventListener(
      'mousedown',
      this.handleStartClickOutside,
      false
    );
    document.removeEventListener(
      'mousedown',
      this.handleEndClickOutside,
      false
    );
  }

  public render() {
    const { t } = this.props;

    const headerStartText = !this.state.startDate
      ? 'MM/DD/YYYY'
      : `${this.state.startDate.format('MM/DD/YYYY')}`;
    const headerEndText = !this.state.endDate
      ? 'MM/DD/YYYY'
      : `${this.state.endDate.format('MM/DD/YYYY')}`;

    const startCalendarStatus = this.state.calendarStartIsOpen
      ? 'opened'
      : 'closed';
    const endCalendarStatus = this.state.calendarEndIsOpen
      ? 'opened'
      : 'closed';

    return (
      <div className="rp-date-range-separated">
        <div className="rp-date-range-separated--header">
          <div className="rp-date-range-separated--header---container">
            <span className="title">{t('dates.startDate')}</span>
            <div
              className="date-range-separated--date-picker-start"
              onClick={this.handleShowStartCalendar}
            >
              <span>{headerStartText}</span>
              <i className="rpds-calendar-today" />
            </div>
          </div>

          <div className="rp-date-range-separated--header---container">
            <span className="title">{t('dates.endDate')}</span>
            <div
              className="date-range-separated--date-picker-end"
              onClick={this.handleShowEndCalendar}
            >
              <span>{headerEndText}</span>
              <i className="rpds-calendar-today" />
            </div>
          </div>
        </div>
        <div
          className={`calendar-start-container ${startCalendarStatus}`}
          ref={(ref: any) => (this.calendarStartRef = ref)}
        >
          {this.state.calendarStartIsOpen ? (
            <DateRangePicker
              className="rp-date-range-separated--start-calendar"
              onSelect={this.setStartDate}
              value={this.state.startDate}
              selectionType="single"
              numberOfCalendars={1}
            />
          ) : (
            <React.Fragment />
          )}
        </div>
        <div
          className={`calendar-end-container ${endCalendarStatus}`}
          ref={(ref: any) => (this.calendarEndRef = ref)}
        >
          {this.state.calendarEndIsOpen ? (
            <DateRangePicker
              className="rp-date-range-separated--end-calendar"
              onSelect={this.setEndDate}
              value={this.state.endDate}
              selectionType="single"
              numberOfCalendars={1}
            />
          ) : (
            <React.Fragment />
          )}
        </div>
      </div>
    );
  }
}

export default DateRangeSeparated;

interface IDateRangeSeparatedProps {
  onDatesSelected(datesRange: any): void;
  t: any;
  dates: { start: moment.Moment | null; end: moment.Moment | null } | null;
}

interface IDateRangeSeparatedState {
  calendarStartIsOpen: boolean;
  calendarEndIsOpen: boolean;
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
}
